<template>
  <li v-if="isVisible">
    <div>
      <router-link
        exact-active-class="nav__link nav__link__secondary--active"
        :class="['nav__link__secondary', {'nav__link__secondary--active':selectedSubChild}]"
        :to="{name: routeName}"
      >
        {{ $t(name) }}
      </router-link>
    </div>
  </li>
</template>

<script>
import companyAccount from "@/imports/mixins/companyAccount";
export default {
  name: "MenuItemSecondary",
  mixins: [companyAccount],
  props: {
    route: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    isVisible: function() {
      if(this.name === 'Listing'){
        return !this.isLimitedAccount;
      }
      return (this.route.meta && (this.route.meta.visible === undefined || this.route.meta.visible))
    },
    name: function() {
      return this.route.meta.text ?? this.route.name.toLowerCase().split("-").map(s => s.charAt(0).toUpperCase() + s.slice(1)).join(" ")
    },
    routeName: function() {
      let route = this.route;
      if(this.route.children && this.route.children.length === 2) {
        route = this.route.children[0];
      }
      return route.name;
    },
    selectedSubChild: function() {
      const activeRoute = this.$route;
      if (this.route.children && this.route.children.length > 0) {
        return this.route.children.find((childRoute) => childRoute.name === activeRoute.name) !== undefined;
      }
      return false;
    }
  }
}
</script>

<style scoped lang="scss">

</style>
